// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  // imagesURL: "http://localhost:44356/images/",
  // baseBillingURL: "https://localhost:44342/api/",
  // baseSharedURL: "http://randyoses-001-site9.btempurl.com",
  // baseMailingURL: "https://synergymailing.azurewebsites.net/api/",
  // baseEBillingURL: "https://synergyebilling.azurewebsites.net/api/",
  // baseAuthenticationURL :  "https://localhost:44353",
  // baseOrganizationURL :   "http://localhost:58332/api",
  imagesURL: "https://ozez23.bsite.net/images/",
  baseBillingURL: "http://randyoses-001-site12.btempurl.com/api/",
  baseSharedURL: "http://randyoses-001-site9.btempurl.com",
  baseMailingURL: "http://randyoses-001-site7.btempurl.com/api/",
  baseEBillingURL: "https://synergyebilling.azurewebsites.net/api/",
  baseAuthenticationURL :  "http://randyoses-001-site3.btempurl.com",
  baseOrganizationURL :   "http://randyoses-001-site6.btempurl.com/api",
  applicayionId: 1
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
